import React, { useContext, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  errorMessage,
  forgetPassword,
  forgetPasswordContainer,
  subtitle1,
  subtitle2,
  subtitleContainer,
} from "./Login.style";
import { USER_DATA, USER_UUID } from "../utils/constants";
import { useNavigate, useLocation } from "react-router-dom";
import ButtonLoading from "../components/ButtonLoading";
import {
  getUser,
  loginGitHub,
  loginGoogle,
  logInWithEmailAndPassword,
} from "../api/user";
import Input from "../components/Input";
import { toast } from "react-toastify";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";
import Copyright from "../components/Copyright";
import Divider from "../components/Divider";
import { colors } from "../assets/colors";
import { UserContext } from "../contexts/UserContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const { setUser } = useContext(UserContext);

  const navigate = useNavigate();
  let location = useLocation();

  let from = location.state?.from?.pathname || "/projects";

  const login = async () => {
    setLoginError(false);

    if (!email || !password) {
      setLoginError(true);
      return;
    }

    setLoading(true);

    logInWithEmailAndPassword(email, password)
      .then((response) => {
        setLoginError(false);
        localStorage.clear();
        loadUserData(response.user.uid);
      })
      .catch((e) => {
        setLoginError(true);
        toast.error("Erro ao realizar login");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loginWithGitHub = async () => {
    setLoginError(false);
    setLoading(true);

    await loginGitHub()
      .then((response: any) => {
        setLoginError(false);
        localStorage.clear();
        loadUserData(response.uid);
      })
      .catch((e) => {
        setLoginError(true);
        toast.error("Erro ao realizar login");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loginWithGoogle = async () => {
    setLoginError(false);
    setLoading(true);

    await loginGoogle()
      .then((response: any) => {
        setLoginError(false);
        localStorage.clear();
        loadUserData(response.uid);
      })
      .catch((e) => {
        setLoginError(true);
        toast.error("Erro ao realizar login");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loadUserData = (uid: string) => {
    getUser(uid)
      .then((response: any) => {
        localStorage.setItem(USER_DATA, JSON.stringify(response));
        localStorage.setItem(USER_UUID, response.uid);

        setUser(response);

        if (response.isValidated !== undefined && response.isValidated) {
          navigate(from, { replace: true });
        } else {
          navigate("/validate", { replace: true });
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    login();
  };

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        sm={false}
        md={7}
        sx={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/back-logo.png"})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Grid
        item
        md={5}
        sx={{
          alignSelf: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={subtitleContainer as React.CSSProperties}>
            <span style={subtitle1}>Bem-vindo!</span> <br />
            <span style={subtitle2}>Conecte-se com seu email e senha</span>
          </div>

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ mt: 1 }}
            style={{ width: 400 }}
          >
            <Input
              title={"E-MAIL"}
              placeholder={"Inserir e-mail"}
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />

            <Input
              title={"SENHA"}
              placeholder={"Inserir senha"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              type="password"
            />

            <div style={forgetPasswordContainer as React.CSSProperties}>
              <Link
                href="/forget-password"
                variant="body2"
                style={forgetPassword}
              >
                Esqueci minha senha
              </Link>
            </div>

            {loginError && (
              <span style={errorMessage}>
                Erro ao realizar login. Verifique seus dados e tente novamente.
              </span>
            )}

            <ButtonLoading label="Acessar" loading={loading} />

            <div
              style={{
                ...forgetPasswordContainer,
                ...{ textAlign: "left", marginTop: 20 },
              }}
            >
              <span>Não tem uma conta?</span>
              <Link
                href="/register"
                variant="body2"
                style={{ ...forgetPassword, ...{ marginLeft: 10 } }}
              >
                Inscreva-se
              </Link>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 20,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Divider />
              <span style={{ marginLeft: 24, marginRight: 24 }}>ou</span>
              <Divider />
            </div>

            <ButtonLoading
              label="Entrar com GitHub"
              loading={loading}
              onClick={loginWithGitHub}
              style={{ backgroundColor: "#000000", color: colors.white }}
              icon={<GitHubIcon style={{ marginRight: 10 }} />}
            />

            <ButtonLoading
              label="Entrar com Google"
              loading={loading}
              onClick={loginWithGoogle}
              style={{ backgroundColor: "#1E90FF", color: colors.white }}
              icon={<GoogleIcon style={{ marginRight: 10 }} />}
            />

            <Copyright />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
